import styled from 'styled-components';
import { mainGray } from '../../assets/ui/colors';

export const CardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: -8px;
`;

export const NotServiceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: calc(100vh - 220px);
`;

export const NotFoundImg = styled.img`
  max-width: 180px;
`;

export const NotFoundTitle = styled.span`
  margin-top: 25px;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: ${mainGray};
  max-width: 220px;
  text-align: center;
`;
